import React from 'react';
import { SeparatorCard, SeparatorInnerCard } from './CircularProgressBar.styled';

function Separator(props: { readonly turns: number }) {
    return (
        <SeparatorCard
            style={{
                transform: `rotate(${props.turns}turn)`,
            }}
        >
            <SeparatorInnerCard />
        </SeparatorCard>
    );
}

function RadialSeparators(props: { count: number }) {
    const turns = 1 / props.count;
    return Array(props.count)
        .fill(null)
        .map((_, index) => <Separator key={index} turns={index * turns + 0.5} />);
}

export default RadialSeparators;
